import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactPaginate from 'react-paginate';
import Postman from '../utils/service';
import { withRouter, Link } from 'react-router-dom';
import LinkedinIcon from 'react-share/lib/LinkedinIcon';
import { encodeforspace } from '../utils/helper';
import EnhancedTableHead from './tableHead';
import { Helmet } from 'react-helmet';
import LazyLoad from 'react-lazyload'
import ReactTooltip from "react-tooltip";

const rows = [
  { id: 'countryRanking', numeric: true, disablePadding: false, label: 'Rank' },
  { id: 'company_name', numeric: false, disablePadding: false, label: 'Company' },
  { id: 'city', numeric: true, disablePadding: false, label: 'City' },
  { id: 'state', numeric: true, disablePadding: false, label: 'State' },
  { id: 'country', numeric: true, disablePadding: false, label: 'Country' },
  { id: 'total_funding_float', numeric: true, disablePadding: false, label: 'Funding' },
  { id: 'Industry', numeric: true, disablePadding: false, label: 'Industry' },
  { id: 'current_employees', numeric: true, disablePadding: false, label: 'Employees' },
  { id: 'Points', numeric: true, disablePadding: false, label: 'Predictive Score' },
];

const styles = theme => ({
  root: {
    width: '100%',
    //height: 645,
    overflowX: 'auto'
  },
  table: {
    minWidth: 820,
    height: 500,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});


class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'asc',
      orderBy: 'ranking',
      offset: 0,
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 100,
      tableData: props.tableData.data || [],
      pageCount: props.tableData.totalCount / 100,
      country: null,
      _page: 0
    };
    this.flag = false;
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy }, () => this.getData());

  };
  handleClick = (event, company, id) => {
    //this.props.onSelectCompany(company, id)
    event.stopPropagation()
    this.props.history.push(`/company/${encodeforspace(company)}`);
  }

  handleChangePage = (event, page) => {
    //this.setState({ page });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  getData = () => {
    const { order, orderBy, offset, rowsPerPage, country } = this.state
    Postman.getCompaniesByCountry(order, orderBy, offset, rowsPerPage, country)
      .then(res => {
        this.setState({ tableData: res.data.data, pageCount: res.data.totalCount / rowsPerPage })
      })

  }

  componentWillReceiveProps(nextProps) {
    var page = nextProps.match.params.page || 1
    const offset = (page - 1) * this.state.rowsPerPage
    var { country } = nextProps.match.params
    this.setState({ country, offset }, () => this.getData())

  }

  handlePageClick = ({ selected }, country) => {
    if (!isNaN(selected)) {
      if (selected > 0) this.props.history.push(`/country/${country}/${selected + 1}`)
      if (selected == 0) this.props.history.push(`/country/${country}`)
    }

    const offset = 0
    this.setState({ offset }, () => this.getData())
  }
  render() {
    const { classes } = this.props;
    const { data, order, orderBy, selected, rowsPerPage, tableData, pageCount } = this.state;
    //TODO list
    //const emptyRows = rowsPerPage-tableData.length;
    const { country } = this.props.match.params
    const page = this.props.match.params.page || 1
    const nextPage = parseInt(page) + 1
    // {(page==2)&&<link rel="prev" href={`https://growjo.com/country/${country}`} />}
    // {(page>1)&&<link rel="prev" href={`https://growjo.com/country/${country}/${page-1}`} />}
    // {(page<pageCount)&&<link rel="next" href={`https://growjo.com/country/${country}/${nextPage}`} />}
    return (
      <div>
        <Helmet>
          <link rel="canonical" href={`https://growjo.com/country/${country}`} />
        </Helmet>
        <Paper className={classes.root}>
          <div style={{ overflowX: 'auto' }}>
            <Table aria-labelledby="tableTitle" style={{ minWidth: 820, height: 500, tableLayout: 'fixed', whiteSpace: 'nowrap' }}>
              <colgroup>
                <col style={{ width: '5%' }} />
                <col style={{ width: '30%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '7%' }} />
                <col style={{ width: '8%' }} />
                <col style={{ width: '9%' }} />
                <col style={{ width: '10%' }} />
                <col style={{ width: '9%' }} />
                <col style={{ width: '10%' }} />
              </colgroup>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
                rowCount={data.length}
                rows={rows}
              />
              <TableBody>
                {tableData.map(n => {
                  const isSelected = this.isSelected(n.id);
                  if (n.country === 'United States') n.country = 'USA';
                  return (
                    <TableRow
                      hover
                      //onClick={event => this.handleClick(event, n.company_name, n.id)}
                      role="checkbox"
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={n.id}
                      selected={isSelected}
                    >
                      <TableCell align="center" style={{ backgroundColor: 'white', padding: 0 }}>{n.countryRanking}</TableCell>
                      <TableCell align="left">
                        <LazyLoad>
                          <a href={`//${n.url}`} target="_blank" onClick={(e) => { e.stopPropagation() }} style={{ fontSize: 15, color: '#13135c', textDecoration: "none" }}>
                            <img src={`https://www.google.com/s2/favicons?domain=${n.url}`} style={{ marginRight: 5, width: 18 }} />
                          </a>
                        </LazyLoad>
                        <Link key={n.id} to={`/company/${encodeforspace(n.company_name)}`} style={{ fontSize: 15 }}>{n.company_name}</Link>
                        <LazyLoad>
                          <div style={{ display: 'inline-block', marginLeft: 8 }}>
                            <a href={n.linkedin_url} target="_blank" onClick={(e) => { e.stopPropagation() }}>
                              <LinkedinIcon size={15} />
                            </a>
                          </div>
                        </LazyLoad>
                      </TableCell>
                      <TableCell align="left">{n.city}</TableCell>
                      <TableCell align="left">{n.state}</TableCell>
                      <TableCell align="left">{n.country}</TableCell>
                      <TableCell align="left">{n.total_funding}</TableCell>
                      <TableCell align="left">{n.Industry}</TableCell>
                      <TableCell align="left" style={{ paddingLeft: 40 }}>
                        <span className="tooltip-icon">
                          <a
                            data-for="custom-class"
                            data-tip="<b>Source: Growjo</b><p>To license the growjo Dataset  
                                  <a target='_new' href='https://growjo.com/schedule-demo'> click here</a></p>"
                            data-html={true}>
                            {n.current_employees}
                          </a>
                          <ReactTooltip
                            id="custom-class"
                            className="extraClass"
                            delayHide={1000}
                            effect="solid"
                          />
                        </span>
                      </TableCell>
                      <TableCell align="left"><strong style={{ marginLeft: 15, color: 'green', fontSize: 15 }}>{n.Points}</strong></TableCell>
                    </TableRow>
                  );
                })}
                {/* {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
              </TableBody>
            </Table>
          </div>
        </Paper>
        <div style={{ float: "right", marginTop: 25 }}>
          <ReactPaginate
            previousLabel={'<<'}
            nextLabel={'>>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={(e) => this.handlePageClick(e, country)}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            initialPage={this.props.match.params.page - 1}
            hrefBuilder={(page) => page == 1 ? `/country/${country}` : `/country/${country}/${page}`}
          />
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(EnhancedTable));


// WEBPACK FOOTER //
// ./client/src/components/dataTableCountry.js